<template>
  <div style="text-align: left; font-size: 0.24rem">
    <ul class="enable-list-type">
      <li>如<span style="color: #ff5455; font-weight: bold;">【存款200人民币】</span>, 您必须要购买<span style="color: #ff5455; font-weight: bold;">【元风卡】</span>。</li>
      <li>在商城购买卡密后请联系商城客服获取卡号及卡密，并复制完整文字，然后回到操作页面点击[自动提取卡密]。</li>
      <li>自动提取卡密后请点击[提交卡密]。</li>
      <li style="color: #ff5455; font-weight: bold;">购买卡密后需即充即用, 如买错卡/ 金额不正确/ 延迟使用, 卡密将不会到账。</li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'Md200073Alert'
}
</script>
